import axios from 'axios'

/**
 * Single accessor for the axios callable.
 *
 * Callers used to write `const { default: axios } = await import('axios')` at each site. The
 * lazily-loaded chunk could resolve without a usable callable, which surfaced only later at the
 * request site as a minified "x is not a function" naming a mangled local and pointing nowhere
 * near the real failure. Axios is imported statically now, so it is part of the main bundle and
 * there is no chunk left to resolve badly.
 *
 * Static is also the cheaper shape here: the funnel cannot render without fetchConfig, and the
 * feature-flag check runs ahead of it, so axios was already being loaded on every session. The
 * split deferred nothing and only added a request in front of time-to-first-question.
 *
 * The guard stays as a cheap assertion against a malformed build, and the async signature is kept
 * so call sites are unaffected and swapping back to a lazy load stays a one-file change.
 *
 * @returns {Promise<Function>} The axios callable
 * @throws {Error} When axios did not resolve to a callable
 */
export const loadAxios = async () => {
  if (typeof axios !== 'function') {
    throw new Error('axios failed to load: module resolved without a callable export')
  }

  return axios
}

export default loadAxios
